/* prettier-ignore */
export default class WelcomeToTheJungleJobs {
  init() {
    this.options = {
      apiHost: 'https://www.welcomekit.co',
      group: 'job',
      locale: 'fr',
      display: [],
      website: null,
    };
    this.fetchJobs();
  }

  async fetchJobs() {
    const loadingIndicator = document.createElement('div');

    loadingIndicator.id = 'loading-indicator';
    loadingIndicator.style.textAlign = 'center';
    loadingIndicator.style.margin = '20px';
    loadingIndicator.innerText = 'Chargement des offres d\'emploi...';

    const jobContainer = document.getElementById('welcomekit-embed');

    if (!jobContainer) {
      return;
    }

    jobContainer.appendChild(loadingIndicator);

    try {
      const response = await fetch(
        `${this.options.apiHost}/api/v1/embed/?organization_reference=22qMKkO`
      );

      if (response.ok) {
        const data = await response.json();

        loadingIndicator.style.display = 'none';

        if (data.jobs && data.jobs.length > 0) {
          jobContainer.innerHTML = this.displayJobs(data.jobs);
        } else {
          loadingIndicator.innerText = 'Aucune offre d\'emploi trouvée.';
        }
      } else {
        loadingIndicator.innerText =
                    'Erreur lors de la récupération des offres d\'emploi.';
      }
    } catch (error) {
      loadingIndicator.innerText =
                'Erreur lors de la récupération des offres d\'emploi.';
    }
  }

  displayJobs(jobs) {
    let output = '<ul class="welcome-to-the-jungle-offer-list__list">';

    jobs.forEach((job) => {
      output += `
        <li class="wk-job-post-card">
          <a class="wk-job-post-card__wrapper" href="${this.jobUrl(job)}" target="_blank">
            <div class="wk-job-post-card__title-wrapper">
              <h3 class="wk-job-post-card__name">${job.name}</h3>
              <ul class="wk-job-post-card__infos">
                <li class="wk-job-post-card__officeCity">${this.renderOfficeCities(job)}</li>
                <li class="wk-job-post-card__contractType">${job.contract_type ? job.contract_type[this.options.locale] : ''}</li>
              </ul>
            </div>
            <button class="wk-job-post-card__fake-button">Postulez</button>
          </a>
        </li>
      `;
    });
    output += '</ul>';

    return output;
  }

  jobUrl(job) {
    if (job.websites_urls.length) {
      const websiteToUse = job.websites_urls.filter((wu) => {
        return (
          wu.website_reference === this.options.website ||
                    `wk-careers_${wu.website_reference}` === this.options.website
        );
      });

      if (websiteToUse.length) {
        return websiteToUse[0].url;
      }

      return job.websites_urls[0].url;
    }

    return this.data.websites[0].root_url;
  }

  renderOfficeCities(job) {
    if (job.offices) {
      const cities = this.unique(job.offices.map((office) => office.city));

      return this.truncate(cities.join(', '), 40);
    }

    if (job.office) {
      return job.office.city;
    }

    return '';
  }

  truncate(str, num) {
    if (str.length <= num) {
      return str;
    }

    return `${str.slice(0, num)}...`;
  }

  unique(array) {
    const set = new Set(array);

    return Array.from(set);
  }
}
